import { render, staticRenderFns } from "./Temoignages.vue?vue&type=template&id=61834249&scoped=true&"
import script from "./Temoignages.vue?vue&type=script&lang=js&"
export * from "./Temoignages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61834249",
  null
  
)

export default component.exports